import "core-js/modules/es6.function.name";
import CommonIcon from '_c/common-icon';
import { showTitle as _showTitle } from '@/libs/util';
export default {
  components: {
    CommonIcon: CommonIcon
  },
  methods: {
    showTitle: function showTitle(item) {
      return _showTitle(item, this);
    },
    showChildren: function showChildren(item) {
      return item.children && (item.children.length > 1 || item.meta && item.meta.showAlways);
    },
    getNameOrHref: function getNameOrHref(item, children0) {
      return item.href ? "isTurnByHref_".concat(item.href) : children0 ? item.children[0].name : item.name;
    }
  }
};